// @flow

import { Error } from 'error';

export default class TraceKitContextSubscriber {
	onError (ctx: Object, error: Error) { // eslint-disable-line no-unused-vars
		throw new Error('Not implemented (abstract)');
	}

	subscribe (traceKit: *) {
		traceKit.context.subscribe(this.onError.bind(this));
	}
}
